import { DISCORD_URL } from 'features/pages/slice';

import {
  Heading,
  Icon,
  Image,
  Jumbotron,
  LinkWithButtonStyles,
} from '@frontendmentorio/design-system-v2';

export default function Hero() {
  return (
    <Jumbotron className="flex flex-col gap-5 px-5 py-9 w-full tablet:items-center tablet:text-center">
      <Heading className="max-w-[30ch] text-blue-500" level="1">
        Join our community of friendly, supportive developers
      </Heading>

      <p className="max-w-prose text-lg text-neutral-500">
        Join our Discord to ask questions, share projects, and get help from
        fellow developers. Whether you're tackling a challenge or chatting about
        web development, our friendly community is here for you.
      </p>

      <LinkWithButtonStyles
        className="gap-2 mb-6 tablet:mb-8"
        href={DISCORD_URL}
      >
        <Icon name="discord" style="brands" />
        Join our Discord
      </LinkWithButtonStyles>

      <Image
        alt=""
        className="max-w-[62rem] w-full"
        height={750}
        priority
        quality={100}
        src="/static/images/community-hero.webp"
        width={1485}
      />
    </Jumbotron>
  );
}
